import React, { useState, useEffect, useRef } from "react";
import Loader from "../../components/Common/Loader";

const LatestUpdate = () => {
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    const handleLoad = () => {
      setLoading(false);
    };

    if (iframe) {
      iframe.addEventListener("load", handleLoad);
    }

    return () => {
      if (iframe) {
        iframe.removeEventListener("load", handleLoad);
      }
    };
  }, []);

  return (
    <div style={{ height: "98%", width: "100%", position: "relative" }}>
      {loading && <Loader />}
      <iframe
        ref={iframeRef}
        src="https://apex-website-dev-hdhcdgfvfvbse4aa.westus2-01.azurewebsites.net"
        style={{ border: "none", width: "100%", height: "100%" }}
        title="Latest Update"
      ></iframe>
    </div>
  );
};

export default LatestUpdate;
